import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateTenant } from "api/tenants";

import { TenantPerson } from "js/components/types";

import { queryKeys } from "./queryKeys";

export const useUpdateTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      data,
      id,
      queryParams,
    }: {
      data: TenantPerson;
      id: string;
      queryParams?: object;
    }) => updateTenant(data, id, queryParams),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.lists() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenants.detail(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenants.organization(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenantReports.lists(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenantReports.all,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.contracts.lists(),
      });
    },
  });
};
